import React from 'react';
import { useTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import EmptyState from './EmptyState';
import Button from '../Button';

const EmptyStatePhysicians = ({ onClick }) => {
  const { t } = useTranslation('components');

  return (
    <EmptyState
      title={t('AddressBook.EmptyStatePhysicians.title')}
      boxLabels={t('AddressBook.EmptyStatePhysicians.box_labels', { returnObjects: true })}
      info={t('AddressBook.EmptyStatePhysicians.info', { allowHtml: true })}
    >
      <span>{t('AddressBook.EmptyStatePhysicians.info_pre_link_button', { allowHtml: true })}</span>
      <Button kind="link" className="inline" onClick={onClick}>
        {t('AddressBook.EmptyStatePhysicians.link_button_text')}
      </Button>
      <span>
        {t('AddressBook.EmptyStatePhysicians.info_pre_email_button', { allowHtml: true })}
      </span>
      <Button kind="link" className="inline" onClick={onClick}>
        {t('AddressBook.EmptyStatePhysicians.email_button_text')}
      </Button>
    </EmptyState>
  );
};

EmptyStatePhysicians.propTypes = {
  onClick: PropTypes.func,
};

EmptyStatePhysicians.defaultProps = {
  onClick: () => {},
};

export default EmptyStatePhysicians;
